/**
 * TableButton  component
 *
 * @package editor
 * @copyright 2021-2025 Hexio a.s. <contact@hexio.io> (hexio.io) and contributors.
 * @license Apache-2.0
 *
 * See LICENSE file distributed with this source code for more information.
 */

import React from "react";
import { Button, IButtonProps } from "../Button/Button";
import { BEM } from "@adapptio/lib-components";

export interface ITableButtonProps extends IButtonProps {}

export const TableButton: React.FC<ITableButtonProps> = (props) => {
	const baseClass = BEM("edt-table-button");

	return <Button {...props} baseClass={baseClass} />;
};
